(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  document.addEventListener('DOMContentLoaded', () => {
    const logo = document.querySelector('.-by-logo');
    if (logo) {
      const height = getComputedStyle(logo).height;
      console.log(` logo: height = ${height}`);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  function initStarlessHeaderScroll() {
    const sectionHeader = document.querySelector('.section-header');
    const headerWrapper = document.querySelector('.section-header > .header-wrapper, .section-header > sticky-header, .section-header > static-header');

    if (!sectionHeader || !headerWrapper) return;

    function lockHeaderPosition() {
      headerWrapper.style.position = 'fixed';
      headerWrapper.style.top = '0';
      headerWrapper.style.left = '0';
      headerWrapper.style.right = '0';
      headerWrapper.style.width = '100%';
      headerWrapper.style.zIndex = '9999';
      headerWrapper.style.transform = 'translateY(0)';
    }

    function updateHeaderState() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      sectionHeader.classList.remove('shopify-section-header-hidden');
      sectionHeader.classList.add('shopify-section-header-sticky');

      headerWrapper.classList.remove('shopify-section-header-hidden');
      headerWrapper.classList.add('shopify-section-header-sticky');

      lockHeaderPosition();

      if (scrollTop > 30) {
        document.body.classList.add('starless-header-scrolled');
        sectionHeader.classList.add('starless-header-scrolled');
        sectionHeader.classList.add('scrolled-past-header');
        headerWrapper.classList.add('starless-header-scrolled');
        headerWrapper.classList.add('scrolled-past-header');
      } else {
        document.body.classList.remove('starless-header-scrolled');
        sectionHeader.classList.remove('starless-header-scrolled');
        sectionHeader.classList.remove('scrolled-past-header');
        headerWrapper.classList.remove('starless-header-scrolled');
        headerWrapper.classList.remove('scrolled-past-header');
      }
    }

    updateHeaderState();

    if (window.starlessHeaderScrollHandler) {
      window.removeEventListener('scroll', window.starlessHeaderScrollHandler);
    }

    window.starlessHeaderScrollHandler = updateHeaderState;

    window.addEventListener('scroll', window.starlessHeaderScrollHandler, { passive: true });
    window.addEventListener('resize', updateHeaderState);

    setTimeout(updateHeaderState, 100);
    setTimeout(updateHeaderState, 500);
    setTimeout(updateHeaderState, 1000);
  }





  document.addEventListener('DOMContentLoaded', initStarlessHeaderScroll);
  document.addEventListener('shopify:section:load', initStarlessHeaderScroll);
  initStarlessHeaderScroll();

  class StickyHeader extends HTMLElement {
    connectedCallback() {
      initStarlessHeaderScroll();
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  class StaticHeader extends HTMLElement {
    connectedCallback() {
      initStarlessHeaderScroll();
    }
  }

  if (!customElements.get('static-header')) {
    customElements.define('static-header', StaticHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
